/**
 * The rule the review drawer holds: its status, the kind it is confirmed as,
 * and the day it was attested. The drawer's verbs move it the way the app's
 * principle service does.
 */

export const RULE_STATUS = {
  PROPOSED: "proposed",
  CONFIRMED: "confirmed",
  RETIRED: "retired",
  DECLINED: "declined",
} as const;
export type RuleStatus = (typeof RULE_STATUS)[keyof typeof RULE_STATUS];

export const RULE_KIND = {
  POLICY: "policy",
  HEURISTIC: "heuristic",
  BELIEF: "belief",
} as const;
export type RuleKind = (typeof RULE_KIND)[keyof typeof RULE_KIND];

export interface RuleState {
  status: RuleStatus;
  kind: RuleKind;
  /** YYYY-MM-DD, set when the rule is confirmed or reinstated. */
  attestedOn: string | null;
}

/** Said on the leadership sync and waiting in Pending, as a policy. */
export const INITIAL_RULE: RuleState = {
  status: RULE_STATUS.PROPOSED,
  kind: RULE_KIND.POLICY,
  attestedOn: null,
};
